
<div [ngClass]="[showFeedbackToast? orderFeedback === null? 'show': '': '']" class="fb-modal"></div>
<ng-container>
	<div class="w-full flex flex-col justify-start items-start">
		<div class="w-full flex flex-row justify-between md:items-center md:pr-4">
			<h3  class="w-full text-2xl mb-4">Order Details</h3>
			<button *ngIf="showFeedbackBtn"
					(click)="showFeedbackToast = true"
					class="md:w-full md:max-w-[220px] bg-[#fffcf7] rounded border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
	transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm">
				<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
					<path d="m363-390 117-71 117 71-31-133 104-90-137-11-53-126-53 126-137 11 104 90-31 133ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/>
				</svg>
				<p>Rate Order Experience</p>
			</button>
		</div>
		<div *ngIf="orderDetails" class="w-full flex flex-col md:flex-row justify-between items-start md:items-center">
			<div class=" flex flex-col md:flex-row gap-2 justify-center items-start">
				<h4>Ordered on <span class="fb-dark-text">{{orderDetails.createdAt | formatDate}}</span></h4>
				<span class="hidden md:block">|</span>
				<h4>Order <span class="fb-dark-text">#{{orderId}}</span></h4>
			</div>
			<div class="flex justify-center items-center md:pr-4 gap-2">
				<h4>TOTAL</h4>
				<div class="fb-dark-text flex gap-1">
					{{orderDetails.currency}}
					{{orderDetails.total | number: '1.0-2'}}
				</div>
			</div>
		</div>
	</div>

	<fb-order-feedback-toast *ngIf="!isLoading && showFeedbackToast"
							 [ngClass]="[showFeedbackToast? orderFeedback === null? 'newFeedback': 'show': '']"
							 class="fb-order-feedback-toast"
							 [orderId]="orderId"
							 [orderFeedback]="orderFeedback"
							 (onCloseEmitter)="onFeedbackClose()" ></fb-order-feedback-toast>
	<fb-loader *ngIf="isLoading"></fb-loader>

	<section *ngIf="!isLoading"
			 class="flex flex-col lg:flex-row justify-between items-stretch w-full mt-5  min-h-screen gap-2">
		<div  class="flex flex-col justify-start items-start lg:hidden">
			<div (click)="showOrderInformation = !showOrderInformation"
				 class="w-full flex justify-between items-center gap-2.5 cursor-pointer rounded-md bg-[#FFFAF6] p-4">
				<h4  class="font-medium ">Order Information</h4>

				<span *ngIf="showOrderInformation" class="material-symbols-outlined close">
								arrow_drop_up
							</span>
				<span *ngIf="!showOrderInformation"
					  class="material-symbols-outlined open">
								arrow_drop_down
							</span>
			</div>
			<div class=" fb-faq-body" [ngClass]="showOrderInformation? 'order-active': ''">
				<div class="min-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#F7F2F4] flex flex-col justify-start items-start gap-2 w-full">
					<h5 class="font-semibold">Shipping Address</h5>
					<div class="text-sm" *ngIf="orderDetails">
						<div class="">{{orderDetails.address.shippingAddress.name}}</div>
						<div class="flex flex-row flex-wrap justify-start items-start gap-0.5">
							<span class=""> {{orderDetails.address.shippingAddress.addressLineOne}}</span>
							<span class=""> {{orderDetails.address.shippingAddress.addressLineTwo }}</span>
							<span class="">, {{orderDetails.address.shippingAddress.city}}</span>
							<span class="w-full">{{orderDetails.address.shippingAddress.contactEmail}}</span>
						</div>
					</div>
				</div>
				<div class="min-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#E9F0EB] flex flex-col justify-start items-start gap-2 w-full">
					<h5 class="font-semibold">Billing Address</h5>
					<div class="text-sm" *ngIf="orderDetails">
						<div class="">{{orderDetails.address.billingAddress.name}}</div>
						<div class="flex flex-row flex-wrap justify-start items-start gap-0.5">
							<span class=""> {{orderDetails.address.billingAddress.addressLineOne}}</span>
							<span class=""> {{orderDetails.address.billingAddress.addressLineTwo }}</span>
							<span class="">, {{orderDetails.address.billingAddress.city}}</span>
							<span class="w-full">{{orderDetails.address.billingAddress.contactEmail}}</span>
						</div>
					</div>
				</div>

				<div class="min-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#E0DEE4] flex flex-col justify-start items-start gap-2 w-full">
					<h5 class="font-semibold">Order Essentials</h5>
					<div class="w-full text-sm" *ngIf="orderDetails">
						<div class="flex justify-between items-center w-full">
							<span>Shipping Mode: </span>
							<span class=""><span>{{orderDetails.shippingMode.name}}</span></span>
						</div>

						<div class="flex justify-between items-center w-full">
							<span>Sub Total:</span>
							<span class="text-sm">{{orderDetails.currency}} {{orderDetails.subTotal | number: '1.2-2'}}</span>
						</div>

						<div class="flex justify-between items-center w-full">
							<span class="font-bold">Total:</span>
							<span class="text-sm">{{orderDetails.currency}} {{orderDetails.total | number: '1.2-2'}}</span>
						</div>
						<div class="text-xs mt-0.5">(Total includes shipping charges)</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="sortOrderSection && sortOrderSection.length > 0"
			 class="gap-3 flex-[100%] flex flex-col justify-between items-start lg:flex-[70%] w-full relative mb-[40px]">
			<ng-container *ngFor="let sortOrder of sortOrderSection">
				<ng-container *ngIf="sortOrder === 'IN_STOCK'">
					<div *ngIf="inStockOrederItem && inStockOrederItem.length>0"
						 class="w-full flex flex-col justify-start items-start gap-2 rounded-md bg-[#FFFAF6] px-4">
						<div class="w-full flex flex-row justify-between items-start mt-3">
							<h5 class="text-lg ">In-Stock Order</h5>

							<div class="fb-order-status text-sm md:text-base">
								<p class="dispatch_on"
								   *ngIf="(inStockOrederItem[0].orderStatus==='IN_TRANSIT')">Dispatched</p>
								<p [ngClass]="inStockOrederItem[0].orderStatus"
								   *ngIf="inStockOrederItem[0].orderStatus==='CANCELLED'">Cancelled</p>
								<p [ngClass]="inStockOrederItem[0].orderStatus"
								   *ngIf="inStockOrederItem[0].orderStatus==='INITIATED'">Confirmed</p>
								<p [ngClass]="inStockOrederItem[0].orderStatus"
								   *ngIf="inStockOrederItem[0].orderStatus==='PROCESSING'">Processing</p>
								<p [ngClass]="inStockOrederItem[0].orderStatus"
								   *ngIf="inStockOrederItem[0].orderStatus==='DELIVERED'">Delivered</p>
								<p [ngClass]="inStockOrederItem[0].orderStatus"
								   *ngIf="inStockOrederItem[0].orderStatus==='FAILED'">Failed</p>
							</div>

						</div>
						<div class="w-full flex flex-col md:flex-row justify-between items-start pb-4">
							<div class=" flex flex-col items-start justify-start text-sm">
								<p *ngIf="inStockOrederItem[0].shippingCode">
									Tracking Code: <span class="fb-dark-text">{{inStockOrederItem[0].shippingCode}} </span>
								</p>
								<p *ngIf="inStockOrederItem[0].dispatchedOn">
									Dispatched On: <span class="fb-dark-text">{{inStockOrederItem[0].dispatchedOn | formatDate}}</span>
								</p>
								<p>
									Estimated Delivery: <span class="fb-dark-text">{{inStockOrederItem[0].estimatedDeliveryTo | formatDate}}</span>
								</p>
								<p>
									Payment Status:
									<span class="fb-dark-text">{{inStockOrederItem[0].paymentStatus | titlecase}}</span>
								</p>
							</div>
							<a *ngIf="inStockOrederItem[0].trackingUrl"
							   class="rounded-md bg-[#93805e] text-white px-3 py-1.5 mt-3 text-sm"
							   [href]="inStockOrederItem[0].trackingUrl"
							   target="_blank" rel="nofollow">
								<button>Track Order</button>
							</a>

							<a *ngIf="!inStockOrederItem[0].dispatchedOn &&
						inStockOrederItem[0].orderStatus!='FAILED' && inStockOrederItem[0].orderStatus!=='CANCELLED'"
							   [ngClass]="hideCancelButton? 'fb-cancel-disabled': ''"
							   class="rounded-md bg-white shadow px-3 py-1.5 mt-3 text-sm">
								<button [disabled]="hideCancelButton"
										(click)="cancelOrder(orderDetails!.id?orderDetails!.id:0)">Cancel Order</button>
							</a>

						</div>
						<div class="grid grid-cols-2 gap-4 items-start mb-3">
							<ng-container *ngFor="let product of inStockOrederItem">
								<div class="">
									<fb-instock-ordered-item [product]="product"
															 [reviewOrderItemId]="reviewOrderItemId"
															 [inStockOrederItem]="inStockOrederItem"></fb-instock-ordered-item>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="sortOrder === 'MADE_TO_ORDER'">
					<div *ngIf="madeToOrederItem && madeToOrederItem.length>0"
						 class="w-full flex flex-col justify-start items-start gap-2 rounded-md bg-[#FFFAF6] px-4">
						<div class="w-full flex flex-row justify-between items-start mt-3">
							<h5 class="text-lg ">Made To Order</h5>

							<div class="fb-order-status text-sm md:text-base">
								<p class="dispatch_on"
								   *ngIf="(madeToOrederItem[0].orderStatus==='IN_TRANSIT')">Dispatched</p>
								<p [ngClass]="madeToOrederItem[0].orderStatus"
								   *ngIf="madeToOrederItem[0].orderStatus==='CANCELLED'">Cancelled</p>
								<p [ngClass]="madeToOrederItem[0].orderStatus"
								   *ngIf="madeToOrederItem[0].orderStatus==='INITIATED'">Confirmed</p>
								<p [ngClass]="madeToOrederItem[0].orderStatus"
								   *ngIf="madeToOrederItem[0].orderStatus==='PROCESSING'">Processing</p>
								<p [ngClass]="madeToOrederItem[0].orderStatus"
								   *ngIf="madeToOrederItem[0].orderStatus==='DELIVERED'">Delivered</p>
								<p [ngClass]="madeToOrederItem[0].orderStatus"
								   *ngIf="madeToOrederItem[0].orderStatus==='FAILED'">Failed</p>
							</div>

						</div>
						<div class="w-full flex flex-col md:flex-row justify-between items-start pb-4">
							<div class=" flex flex-col items-start justify-start text-sm">
								<p *ngIf="madeToOrederItem[0].shippingCode">
									Tracking Code: <span class="fb-dark-text">{{madeToOrederItem[0].shippingCode}} </span>
								</p>
								<p *ngIf="madeToOrederItem[0].dispatchedOn">
									Dispatched On: <span class="fb-dark-text">{{madeToOrederItem[0].dispatchedOn | formatDate}}</span>
								</p>
								<p>
									Estimated Delivery: <span class="fb-dark-text">{{madeToOrederItem[0].estimatedDeliveryTo | formatDate}}</span>
								</p>
								<p>
									Payment Status:
									<span class="fb-dark-text">{{madeToOrederItem[0].paymentStatus | titlecase}}</span>
								</p>
							</div>
							<a *ngIf="madeToOrederItem[0].trackingUrl"
							   class="rounded-md bg-[#93805e] text-white px-3 py-1.5 mt-3 text-sm"
							   [href]="madeToOrederItem[0].trackingUrl"
							   target="_blank" rel="nofollow">
								<button>Track Order</button>
							</a>

							<a *ngIf="!madeToOrederItem[0].dispatchedOn &&
						madeToOrederItem[0].orderStatus!='FAILED' && madeToOrederItem[0].orderStatus!=='CANCELLED'"
							   [ngClass]="hideCancelButton? 'fb-cancel-disabled': ''"
							   class="rounded-md bg-white shadow px-3 py-1.5 mt-3 text-sm">
								<button [disabled]="hideCancelButton"
										(click)="cancelOrder(orderDetails!.id?orderDetails!.id:0)">Cancel Order</button>
							</a>

						</div>
						<div class="w-full flex flex-col justify-center items-center gap-6 mb-3">
							<ng-container *ngFor="let product of madeToOrederItem">
								<div class="">
									<fb-made-to-ordered-item [reviewOrderItemId]="reviewOrderItemId"
															 [orderItemId]="orderItemId"
															 [orderId]="orderId"
															 [product]="product"></fb-made-to-ordered-item>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="sortOrder === 'PRE_ORDER'">
					<div *ngIf="preOrederItem && preOrederItem.length>0"
						 class="w-full flex flex-col justify-start items-start gap-2 rounded-md bg-[#FFFAF6] px-4">
						<div class="w-full flex flex-row justify-between items-start mt-3">
							<span class="sticky_landing" id="remaining_pay_cont"></span>

							<h5 class="text-lg ">Pre Order</h5>
							<div class="fb-order-status text-sm md:text-base">
								<p class="dispatch_on"
								   *ngIf="(preOrederItem[0].orderStatus==='IN_TRANSIT')">Dispatched</p>
								<p [ngClass]="preOrederItem[0].orderStatus"
								   *ngIf="preOrederItem[0].orderStatus==='CANCELLED'">Cancelled</p>
								<p [ngClass]="preOrederItem[0].orderStatus"
								   *ngIf="preOrederItem[0].orderStatus==='INITIATED'">Confirmed</p>
								<p [ngClass]="preOrederItem[0].orderStatus"
								   *ngIf="preOrederItem[0].orderStatus==='PROCESSING'">Processing</p>
								<p [ngClass]="preOrederItem[0].orderStatus"
								   *ngIf="preOrederItem[0].orderStatus==='DELIVERED'">Delivered</p>
								<p [ngClass]="preOrederItem[0].orderStatus"
								   *ngIf="preOrederItem[0].orderStatus==='FAILED'">Failed</p>
							</div>
						</div>
						<div class="w-full flex flex-col md:flex-row justify-between items-start pb-2">
							<div class=" flex flex-col items-start justify-start text-sm">
								<p *ngIf="preOrederItem[0].shippingCode">
									Tracking Code: <span class="fb-dark-text">{{preOrederItem[0].shippingCode}} </span>
								</p>
								<p *ngIf="preOrederItem[0].dispatchedOn">
									Dispatched On: <span class="fb-dark-text">{{preOrederItem[0].dispatchedOn | formatDate}}</span>
								</p>
								<p>
									Estimated Delivery: <span class="fb-dark-text">{{preOrederItem[0].estimatedDeliveryTo | formatDate}}</span>
								</p>
								<p>
									Payment Status:
									<span class="fb-dark-text">{{preOrederItem[0].paymentStatus | titlecase}}</span>
								</p>
							</div>
							<a *ngIf="preOrederItem[0].trackingUrl"
							   class="rounded-md bg-[#93805e] text-white px-3 py-1.5 mt-3 text-sm"
							   [href]="preOrederItem[0].trackingUrl"
							   target="_blank" rel="nofollow">
								<button>Track Order</button>
							</a>

							<a *ngIf="!preOrederItem[0].dispatchedOn &&
						preOrederItem[0].orderStatus!='FAILED' && preOrederItem[0].orderStatus!=='CANCELLED'"
							   [ngClass]="hideCancelButton? 'fb-cancel-disabled': ''"
							   class="rounded-md bg-white shadow px-3 py-1.5 mt-3 text-sm">
								<button [disabled]="hideCancelButton"
										(click)="cancelOrder(orderDetails!.id?orderDetails!.id:0)">Cancel Order</button>
							</a>

						</div>
						<div class="w-full flex flex-row justify-between items-center pb-4"
							 *ngIf="orderDetails && showRemainingPayButton">
							<div class="text-sm flex flex-col md:flex-row">
								<span>Remaining Pay Amount:</span> <strong class="fb-dark-text">&nbsp; {{orderDetails.currency|uppercase}} {{(orderDetails.remainingPay?orderDetails.remainingPay:0) | number: '1.0-2'}}</strong>
							</div>
							<button class="rounded-md bg-[#93805e] text-white px-3 py-1.5 text-sm"
									(click)="remainingPay()">Pay Now</button>
						</div>
						<div class="w-full flex flex-col justify-center items-center gap-6 mb-3">
							<ng-container *ngFor="let product of preOrederItem">
								<div class="">
									<fb-pre-ordered-item [reviewOrderItemId]="reviewOrderItemId"
														 [orderItemId]="orderItemId"
														 [orderId]="orderId"
														 [product]="product"></fb-pre-ordered-item>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="orderDetails && orderDetails.note">
				<h5 class="smallheader">Order Note</h5>
				<div class="order_row">
					{{orderDetails.note}}
				</div>
			</ng-container>
		</div>
		<div class="lg:flex-[30%] w-full relative hidden lg:block mx-2">
			<div class="max-w-[280px] min-h-[150px] px-3 py-5 mb-4 rounded-md bg-[#F7F2F4] flex flex-col justify-start items-start gap-2 w-full">
				<h5 class="font-semibold">Shipping Address</h5>
				<div class="text-sm" *ngIf="orderDetails">
					<div class="">{{orderDetails.address.shippingAddress.name}}</div>
					<div class="flex flex-row flex-wrap justify-start items-start gap-0.5">
						<span class=""> {{orderDetails.address.shippingAddress.addressLineOne}}</span>
						<span class=""> {{orderDetails.address.shippingAddress.addressLineTwo }}</span>
						<span class="">, {{orderDetails.address.shippingAddress.city}}</span>
						<span class="w-full">{{orderDetails.address.shippingAddress.contactEmail}}</span>
					</div>
				</div>
			</div>
			<div class="max-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#E9F0EB] flex flex-col justify-start items-start gap-2 w-full">
				<h5 class="font-semibold">Billing Address</h5>
				<div class="text-sm" *ngIf="orderDetails">
					<div class="">{{orderDetails.address.billingAddress.name}}</div>
					<div class="flex flex-row flex-wrap justify-start items-start gap-0.5">
						<span class=""> {{orderDetails.address.billingAddress.addressLineOne}}</span>
						<span class=""> {{orderDetails.address.billingAddress.addressLineTwo }}</span>
						<span class="">, {{orderDetails.address.billingAddress.city}}</span>
						<span class="w-full">{{orderDetails.address.billingAddress.contactEmail}}</span>
					</div>
				</div>
			</div>
			<div class="max-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#E0DEE4] flex flex-col justify-start items-start gap-2 w-full">
				<h5 class="font-semibold">Order Essentials</h5>
				<div class="w-full text-sm" *ngIf="orderDetails">
					<div class="flex justify-between items-center w-full">
						<span>Shipping Mode: </span>
						<span class=""><span>{{orderDetails.shippingMode.name}}</span></span>
					</div>

					<div class="flex justify-between items-center w-full">
						<span>Sub Total:</span>
						<span class="text-sm">{{orderDetails.currency}} {{orderDetails.subTotal | number: '1.2-2'}}</span>
					</div>

					<div class="flex justify-between items-center w-full">
						<span class="font-bold">Total:</span>
						<span class="text-sm">{{orderDetails.currency}} {{orderDetails.total | number: '1.2-2'}}</span>
					</div>
					<div class="text-xs mt-0.5">(Total includes shipping charges)</div>
				</div>
			</div>

		</div>
	</section>
	<ng-container>




	</ng-container>

</ng-container>
